// extracted by mini-css-extract-plugin
module.exports = {"card":"Card__card__1_xMu"};